import React, { useState, useEffect, useRef } from 'react';

export default function WizardSelectActualPrinciplesForm({ principleData, onDataChange, initialData }) {
    const [selectedActualPrinciples, setSelectedActualPrinciples] = useState(initialData.selectedActualPrinciples || []);
    const onDataChangeRef = useRef(onDataChange);

    // Update ref when callback changes
    useEffect(() => {
        onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    // Only call onDataChange when actual data changes, not when callback changes
    useEffect(() => {
        if (onDataChangeRef.current) {
            onDataChangeRef.current({ selectedActualPrinciples });
        }
    }, [selectedActualPrinciples]);

    // This would typically fetch actual principles based on the selected principle
    // For now, using placeholder data
    const actualPrinciples = [
        'The Given Set of Communication Principle',
        'The Given Set of Information Principle',
        'The Given Set of Instrumentation Principle',
        'The Given Set of Education Principle',
        'The Given Set of Power Principle',
        'The Given Set of Marketing Principle',
        'The Given Set of Exchange Principle',
        'The Given Set of Gaming Principle',
        'The Given Set of Work Principle',
        'The Given Set of Reproduction Principle'
    ];

    const handleTogglePrinciple = (principle) => {
        setSelectedActualPrinciples(prev => {
            if (prev.includes(principle)) {
                return prev.filter(p => p !== principle);
            } else {
                return [...prev, principle];
            }
        });
    };

    return (
        <div className="wizard-select-actual-principles-form">
            <h2 className="wizard-step-heading">Select Actual Principle</h2>
            <div className="actual-principles-list">
                {actualPrinciples.map((principle, index) => (
                    <div
                        key={index}
                        className={`actual-principle-option ${selectedActualPrinciples.includes(principle) ? 'selected' : ''}`}
                        onClick={() => handleTogglePrinciple(principle)}
                    >
                        <div className="actual-principle-option-content">
                            <div className="actual-principle-number-label">
                                <span className="actual-principle-number">{index + 1}.</span>
                                <span className="actual-principle-label">{principle}</span>
                            </div>
                            <input
                                type="checkbox"
                                checked={selectedActualPrinciples.includes(principle)}
                                onChange={() => handleTogglePrinciple(principle)}
                                className="actual-principle-checkbox"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
